var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "79.00 514.75 29.25 24.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#f39800",
    d: "M93.54,514.8h9.06l-4.67,5.4-3.81-5.09c-.03-.07-.1-.14-.17-.17-.31-.24-.76-.14-1,.17l-3.63,5.09-4.64-5.4h8.86ZM103.82,515.56l4.5,5.09h-8.86l4.36-5.09ZM108.32,522.07l-14.22,16.81c-.28.31-.73.35-1,.1-.07-.03-.1-.1-.14-.14l-13.8-16.78h9.76l3.94,16.5c.03.24.24.48.52.55.38.1.76-.14.86-.52l4.29-16.54h9.79ZM79.15,520.65l4.36-5.05,4.36,5.05h-8.72ZM90.78,520.65h5.71l-2.94-3.94-2.77,3.94ZM97.07,522.07h-6.71l3.22,13.42,3.49-13.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond_icon.36507c098d5a28162b04853e6d1bd85f.svg";
export { ForwardRef as ReactComponent };